module.exports = __webpack_public_path__ + "img/Switch (1).df51ca04.svg";